export const MAP_TYPES_OPTIONS = {
  CheckboxGroup: 'CHECKBOX_GROUP',
  RadioGroup: 'RADIO_GROUP',
  RadioGroupEmailSignature: 'RADIO_GROUP_EMAIL_SIGNATURE',
  InputNumber: 'INPUT_NUMBER',
  InputNumberSizes: 'INPUT_NUMBER_SIZES',
  InputNumberBanner: 'INPUT_NUMBER_BANNER',
  Text: 'TEXT'
};
